import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

export const BuyTogetherStyle = css`
  .buy-together-mobile-container {
    padding: 12px 16px 16px;
    margin-top: 8px;
    background-color: ${colors.white.shade1};
  }
  .divider-line {
    display: none;
    @mixin phabletToDesktop {
      display: block;
      margin: 20px 0;
      box-sizing: border-box;
      height: 1px;
      width: 100%;
      border: 1px solid ${colors.gray.shade3};
    }
  }
`;
